import CancelButton from "../../../../../../../modules/clientNotes/components/Buttons/CancelButton";
import SaveButton from "../../../../../../../modules/clientNotes/components/Buttons/SaveButton";

const DownloadConfirmation = ({ reportName, closeModal, setConfirmation }) => {
  return (
    <div
      id="Content-Confirm-Delete-Law-Firm-Teams"
      data-testid="Content-Confirm-Delete-Law-Firm-Teams"
    >
      <div className="mb-8 text-2xl text-center">
        Are you sure you want to download {reportName}?
      </div>

      <div className="flex gap-8">
        <CancelButton label="Cancel" onClick={() => closeModal()} />
        <SaveButton label="Download" onClick={() => setConfirmation(true)} />
      </div>
    </div>
  );
};
export default DownloadConfirmation;
